import { RoleSystemTest } from "@/components/admin/RoleSystemTest";
import { CandidateLayout } from "@/components/candidate/CandidateLayout";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function RoleTest() {
  usePageMeta({ title: "Teste de Roles - Data Hire Club", description: "Teste de sistema de roles", noindex: true });

  return (
    <CandidateLayout maxWidth="4xl">
      <div className="mb-6">
        <h1 className="text-3xl font-bold mb-2">Teste do Sistema de Roles</h1>
        <p className="text-muted-foreground">FASE 2: Validação da migração segura de roles</p>
      </div>
      <RoleSystemTest />
      <div className="mt-8 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
        <h3 className="font-semibold text-yellow-900 mb-2">⚠️ Esta é uma página de teste</h3>
        <ul className="text-sm text-yellow-800 space-y-1 list-disc list-inside">
          <li>Apenas para validação da FASE 2</li>
          <li>Não afeta funcionalidades existentes</li>
          <li>Pode ser removida após validação completa</li>
        </ul>
      </div>
    </CandidateLayout>
  );
}
